import { makeStyles } from 'lib/components';

export default makeStyles((theme) => {
  const chipColors = [
    {
      background: theme.evPalette.ocean[200],
      color: theme.evPalette.ocean[800],
    },
    {
      background: theme.evPalette.mango[100],
      color: theme.evPalette.mango[900],
    },
    {
      background: theme.evPalette.lime[100],
      color: theme.evPalette.lime[900],
    },
    {
      background: theme.evPalette.raspberry[100],
      color: theme.evPalette.raspberry[900],
    },
  ];

  return ({
    buildingDetailsContainer: (({ index, focusedPointIndex }) => ({
      padding: '8px',
      columnGap: '8px',
      rowGap: '16px',
      borderBottom: index + 1 === focusedPointIndex ? 'none' : `1px solid ${theme.evPalette.charcoal[400]}`,
      '&:last-of-type': {
        border: 'none',
      },
      '&.focused': {
        backgroundColor: theme.evPalette.ocean[700],
        '& p': { color: `${theme.evPalette.salt[100]} !important` },
        borderRadius: '4px',
        border: 'none',
      },
    })),
    buildingDetails: {
      flex: 1,
      cursor: 'pointer',
    },
    buildingIdChip: ({ index }) => ({
      ...chipColors[index % chipColors.length],
      borderRadius: '12px',
      alignItems: 'center',
      height: '18px',
      padding: '2px 8px',
      minWidth: '23px',
      margin: '0 6px',
      '& >span': { padding: 0 },
    }),
    buildingDetailsAddress: {
      fontStyle: 'normal',
      fontWeight: 400,
      lineHeight: '24px',
      color: theme.evPalette.charcoal[900],
      fontSize: '16px',
      marginTop: '6px',
    },
    editOutlineButton: {
      textAlign: 'center',
      boxSizing: 'border-box',
      width: '48px',
      height: '32px',
      border: `1px solid ${theme.evPalette.ocean[500]}`,
      borderRadius: '4px',
      backgroundColor: theme.evPalette.salt[100],

    },
    helperText: {
      fontStyle: 'normal',
      fontWeight: 600,
      fontSize: '12px',
      lineHeight: '18px',
      color: theme.evPalette.charcoal[800],
      '& >.myev-MuiFormLabel-asterisk': {
        color: theme.evPalette.rose[900],
      },
    },
    editBuildingLabel: {
      fontStyle: 'normal',
      fontWeight: 600,
      fontSize: '12px',
      lineHeight: '18px',
      textTransform: 'uppercase',
      color: theme.evPalette.charcoal[800],
      marginBottom: '8px',
      '& >.myev-MuiFormLabel-asterisk': {
        color: theme.evPalette.rose[900],
      },
      '&.postalcode': {
        whiteSpace: 'nowrap',
      },
      '&.error': {
        color: theme.evPalette.rose[900],
      },
    },
    inputHelperText: {
      color: `${theme.evPalette.rose[900]} !important`,
    },
    inputTextField: {
      height: '44px',
      '&.select': {
        paddingTop: 0,
        paddingBottom: 0,
        display: 'flex',
        alignItems: 'center',
      },
      '&.Mui-error > fieldset': { borderColor: `${theme.evPalette.rose[900]} !important` },
    },
    editAddressRow: {
      columnGap: '6px',
    },
    editPropertyInfoHeading: {
      color: theme.evPalette.ocean[700],
      fontWeight: 600,
      fontSize: '18px',
    },
    editComponentButtonRow: {
      display: 'flex',
      columnGap: '4px',
      '&>button': {
        textTransform: 'none',
        fontSize: '16px',
        padding: '10px 16px',
      },
    },
    tryAgainButton: {
      display: 'flex',
      color: theme.evPalette.ocean[600],
      '&:hover': {
        backgroundColor: theme.evPalette.charcoal[300],
      },
    },
  });
});
